import { ReactNode } from 'react';
import { SectionHeader } from '../../common/SectionHeader';
import { MonitorIcon, MicrophoneIcon, EyeIcon } from '../../../assets/icons';
import styles from './HowItWorks.module.css';

interface Step {
  number: string;
  title: string;
  description: string;
  icon: ReactNode;
}

const STEPS: Step[] = [
  {
    number: '01',
    title: 'Launch Solo Sense',
    description: 'Open the app on your Apple Vision Pro. The intuitive interface appears in your space, ready to listen.',
    icon: <MonitorIcon />,
  },
  {
    number: '02',
    title: 'Start listening',
    description: 'Tap to begin transcription. Solo Sense captures ambient audio and converts speech to text in real-time.',
    icon: <MicrophoneIcon />,
  },
  {
    number: '03',
    title: 'See every word',
    description: 'Beautiful, readable captions appear in your field of view. Position them anywhere in your space for the perfect viewing experience.',
    icon: <EyeIcon />,
  },
];

const StepItem = ({ number, title, description, icon }: Step) => (
  <div className={styles.step}>
    <div className={styles.stepContent}>
      <p className={styles.stepNumber}>{number}</p>
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
    <div className={styles.stepVisual}>
      {icon}
    </div>
  </div>
);

export const HowItWorks = () => {
  return (
    <section className={styles.howItWorks} id="how-it-works">
      <SectionHeader
        label="Experience"
        title="Simple by design"
        subtitle="Put on your Vision Pro and start experiencing the world with words."
      />
      <div className={styles.steps}>
        {STEPS.map((step, index) => (
          <StepItem key={index} {...step} />
        ))}
      </div>
    </section>
  );
};
